export default __webpack_public_path__ + "static/img/24fc3a1490d65603d73eb9d8f3c450b9.png";